import { render, staticRenderFns } from "./SidebarClient.vue?vue&type=template&id=6b9abb28&scoped=true"
import script from "./SidebarClient.vue?vue&type=script&lang=js"
export * from "./SidebarClient.vue?vue&type=script&lang=js"
import style0 from "./SidebarClient.vue?vue&type=style&index=0&id=6b9abb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9abb28",
  null
  
)

export default component.exports